module.exports = __webpack_public_path__ + "img/trikoder.7119ada0.svg";